import api from "./api";

const PrivateBlogPostAPI = {
    getAll: () => api.get("/private-blog-posts/paged?PageSize=50&PageNumber=1"),
    getById: (id) => api.get(`/private-blog-posts/details/${id}`),
    update: (data) => api.post(`/private-blog-posts/update`, data),
    insert: (data) => api.post(`/private-blog-posts/insert`, data),
    delete: (id) => api.delete(`/private-blog-posts/delete/${id}`),
};

export default PrivateBlogPostAPI;